<template>
  <div>
     <frontHeaderNavigation></frontHeaderNavigation>
     <div class="center-img">
      <img src="../assets/img/notFound404.jpg" height="400" width="650" alt="页面未找到">
     </div>
  </div>
</template>

<script>
import frontHeaderNavigation from '@c/navigation/frontHeaderNavigation.vue'
export default {
  name: 'notfound',
  components: {
    frontHeaderNavigation
  }
}
</script>

<style lang="less">
.center-img {
  text-align: center;
  margin-top: 160px;
}
</style>
